import type { FilterSaveTargetReason } from '../hooks/useLevelFilters';

/**
 * The i18n key that explains why a save target is disabled. Exhaustive over the
 * union on purpose: every surface that shows a reason renders it whenever it is
 * set, so an unmapped reason would silently blank the text instead of failing
 * the build.
 */
export const SAVE_TARGET_REASON_KEY: Record<FilterSaveTargetReason, string> = {
  no_active_view: 'columnFilters.saveTarget.reason.noActiveView',
  no_view_edit_permission: 'columnFilters.saveTarget.reason.noViewEditPermission',
  permission_pending: 'columnFilters.saveTarget.reason.permissionPending',
  already_applied: 'columnFilters.saveTarget.reason.alreadyApplied',
  link_active: 'columnFilters.saveTarget.reason.linkActive',
  link_exits_first: 'columnFilters.saveTarget.reason.linkExitsFirst',
};
